import { render, staticRenderFns } from "./personalInformationPopup.vue?vue&type=template&id=fc5b1150&scoped=true&"
import script from "./personalInformationPopup.vue?vue&type=script&lang=js&"
export * from "./personalInformationPopup.vue?vue&type=script&lang=js&"
import style0 from "./personalInformationPopup.vue?vue&type=style&index=0&id=fc5b1150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5b1150",
  null
  
)

export default component.exports